import { Link, useNavigate } from "react-router-dom";

const LaunchHero = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-purple-800 to-violet-600 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl tracking-tight font-extrabold text-white sm:text-5xl md:text-6xl">
            <span className="block">Launch Your Product on</span>
            <span className="block text-indigo-200">The Leadrboard Weekly</span>
          </h1>
          <p className="mt-3 max-w-md mx-auto text-base text-indigo-200 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            Get discovered by 50,000+ decision makers. Compete in our weekly launches, earn badges, and increase your visibility.
          </p>
          <div className="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
            <div className="rounded-md shadow">
              <Link to='/launch/submit-product' className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10">
                Submit Your Product
              </Link>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default LaunchHero;
